import { ClaimSessionStatusToText } from '@helpers';
import { useClaimStore } from '@pulse/composables/useClaimStore';
import { useOrdersStore } from '@pulse/composables/useOrdersStore';
import { ClaimCategory } from '@pulse/constants/claims';
import { storeToRefs } from 'pinia';

export default function () {
  return {
    async next() {
      const claimStore = useClaimStore(useRuntimeConfig())();

      const { unfinishedFulfillments } = storeToRefs(claimStore);

      if (
        claimStore.claimCategory !== ClaimCategory.SHIPPING &&
        claimStore?.claimSession &&
        !claimStore?.claimSession?.metadata
      )
        return navigateTo('/process');
      if (
        claimStore.claimCategory !== ClaimCategory.WARRANTY &&
        !unfinishedFulfillments.value.length &&
        claimStore.claimSession.status !== 'RESOLUTION_REVIEW'
      )
        return navigateTo('/resolution');

      if (unfinishedFulfillments.value.length) {
        claimStore.setCurrentShipmentId(unfinishedFulfillments.value[0].id);
      }

      if (
        claimStore.claimSession &&
        !['PROCESS', 'MULTIPLE_SHIPMENTS', 'ISSUES_SHIPMENT_DETAILS'].includes(claimStore.claimSession.status)
      ) {
        return navigateTo(ClaimSessionStatusToText[claimStore.claimSession.status]);
      }

      return navigateTo('/issues');
    },

    async start() {
      const orderStore = useOrdersStore(useRuntimeConfig())();

      const claimStore = useClaimStore(useRuntimeConfig())();

      const hasMultipleEligibleFulfillments = orderStore.eligibleFulfillments.length > 1;

      if (!claimStore.claimSession) return navigateTo('/process');
      if (!hasMultipleEligibleFulfillments) {
        if (claimStore.claimSession.metadata?.claim?.fulfillments) return this.next();

        claimStore.setFulfillmentState(
          orderStore.eligibleFulfillments.map(fulfillment => fulfillment.sourceFulfillmentId),
        );

        return this.next();
      }

      if (claimStore.claimSession && claimStore.claimSession.status !== 'PROCESS') {
        return navigateTo(ClaimSessionStatusToText[claimStore.claimSession.status]);
      }

      return navigateTo(hasMultipleEligibleFulfillments ? '/multiple-shipments' : '/issues');
    },

    async validate() {
      const orderStore = useOrdersStore(useRuntimeConfig())();

      if (!orderStore.currentOrder.fulfillments.length) {
        return navigateTo('/not-shipped');
      }

      if (orderStore.tooSoonToFile) {
        return navigateTo('/too-soon');
      }

      if (orderStore.showTooLateAlert) {
        return navigateTo('/too-late');
      }

      this.start();
    },
  };
}
